
import { z } from "zod";

export const PvSystemProviderValues = ["SUNGEVITY", "SUNRUN", "VIVINT"] as const;
export const PvSystemProviderSchema = z.enum(PvSystemProviderValues);
export const PvSystemProvider = PvSystemProviderSchema.enum;
export type PvSystemProvider = (typeof PvSystemProviderValues)[number];
export const PvSystemProviderDisplayNames = { "SUNGEVITY": "Sungevity $1,000",
"SUNRUN": "Sunrun",
"VIVINT": "Vivint $499", } satisfies Record<PvSystemProvider, string>;
